import React, { useState, ReactNode } from 'react';
import { SwipeableDrawer, Box } from '@mui/material';
import { styled } from '@mui/system';

interface DrawerStyles {
	[key: string]: string | number;
}

const StyledSwipeableDrawer = styled(SwipeableDrawer)<{ styles?: DrawerStyles }>(({ styles }) => ({
	'& .MuiDrawer-paper': {
		height: '90vh',
		width: '100%',
		bottom: 0,
		borderTopLeftRadius: 16,
		borderTopRightRadius: 16,
		...styles,
	},
}));

const DragHandle = styled('div')({
	width: 40,
	height: 6,
	backgroundColor: '#ccc',
	borderRadius: 3,
	position: 'absolute',
	top: 8,
	left: 'calc(50% - 20px)',
	cursor: 'pointer',
});

interface SlidableDrawerProps {
	children: ReactNode;
	isOpen: boolean;
	setIsOpen: (data: boolean) => void;
	onClose?: any;
	styles?: React.CSSProperties; // New styles prop
}

const SlidableDrawer: React.FC<SlidableDrawerProps> = ({
	isOpen,
	setIsOpen,
	children,
	onClose,
	styles = {}, // Default to an empty object if no styles are passed
}) => {
	const toggleDrawer = (open: boolean) => (event?: React.KeyboardEvent | React.MouseEvent) => {
		if (!open && onClose) {
			onClose();
		}

		// Ensure the event is defined before accessing its properties
		if (
			event &&
			event.type === 'keydown' &&
			((event as React.KeyboardEvent).key === 'Tab' ||
				(event as React.KeyboardEvent).key === 'Shift')
		) {
			return;
		}
		setIsOpen(open);
	};

	return (
		<div>
			<StyledSwipeableDrawer
				anchor="bottom"
				open={isOpen}
				//@ts-ignore
				onClose={toggleDrawer(false)}
				//@ts-ignore
				onOpen={toggleDrawer(true)}
				ModalProps={{
					keepMounted: true, // Better open performance on mobile.
				}}
				//@ts-ignore
				styles={styles}
			>
				<Box
					sx={{
						height: '100%',
						backgroundColor: 'background.default',
						position: 'relative',
					}}
					role="presentation"
				>
					<DragHandle />
					{children}
				</Box>
			</StyledSwipeableDrawer>
		</div>
	);
};

export default SlidableDrawer;
